window.addEventListener("DOMContentLoaded", () => {
  const btnCloseMenu = document.querySelector(
    "#btn-close-menu-navigation-responsive"
  );
  const panelMenu = document.querySelector(".mobile .overlay-menu");
  const btnOpenMenu = document.querySelector("#open-menu");

  if (btnCloseMenu && panelMenu) {
    btnCloseMenu.addEventListener("click", () => {
      closeMenuAnimation(panelMenu);
    });
  }

  if (btnOpenMenu && panelMenu) {
    btnOpenMenu.addEventListener("click", () => {
      openMenuAnimation(panelMenu);
    });
  }
});

function openMenuAnimation(panelMenu) {
  panelMenu.style.display = "flex";
  panelMenu.classList.add("animate__animated");
  panelMenu.classList.add("animate__bounceInRight");

  const links = panelMenu.querySelectorAll("a");
  let interval = 0;
  for (const link of links) {
    let className = `animate__delay-${interval}s`;
    link.style.display = "block";
    link.classList.add("animate__animated");
    link.classList.add("animate__fadeInDown");
    link.classList.add("animate__faster");
    link.classList.add(className);
    interval++;
  }

  setTimeout(() => {
    panelMenu.classList.remove("animate__animated");
    panelMenu.classList.remove("animate__bounceInRight");
  }, 1000);
}

function closeMenuAnimation(panelMenu) {
  panelMenu.classList.add("animate__animated");
  panelMenu.classList.add("animate__bounceOutRight");

  setTimeout(() => {
    panelMenu.classList.remove("animate__animated");
    panelMenu.classList.remove("animate__bounceOutRight");

    panelMenu.style.display = "none";
  }, 1000);
}
